import { css, Theme } from '@emotion/react'
import { avatarClasses, typographyClasses } from '@mui/material'

export const root = (theme: Theme) => css`
  margin-top: ${theme.spacing(2)};
`

export const label = (theme: Theme) => css`
  margin-top: ${theme.spacing(2)};

  &.${typographyClasses.root} {
    font-weight: 400;
    font-size: 16px;
    color: ${theme.typographyColors.typographyThree};
  }
`

export const emptyLabel = (theme: Theme) => css`
  margin-top: ${theme.spacing(2)};

  &.${typographyClasses.root} {
    font-weight: 700;
  }
`

export const search = (theme: Theme) => css`
  margin-top: ${theme.spacing(2)};
`

export const table = (theme: Theme) => css`
  margin-top: ${theme.spacing(2)};

  .table-row {
    column-gap: ${theme.spacing(1)};

    padding: ${theme.spacing(0.75, 0.75, 0.75, 1.5)};
  }
`

export const rowIndex = (theme: Theme) => css`
  color: ${theme.colors.typographyThree};
  font-size: 14px;
  font-weight: 700;
`

export const avatarWrapper = () => css`
  .${avatarClasses.root} {
    width: 32px;
    height: 32px;
  }
`

export const longText = () => css`
  width: auto;
`
